import { adminLogin } from '@/api/admin'
import { apiAdminToUi } from '@/api/adapters'

const LOGIN_KEY = 'sys_login_ok'

export default {
  namespaced: true,
  state: {
    token: null,
    user: null
  },
  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
    }
  },
  actions: {
    login({ commit }, { username, password, remember }) {
      return adminLogin({
        account: username.trim(),
        password
      }).then(res => {
        const d = res.data
        const user = apiAdminToUi(d)
        const token = d.token
        const storage = remember ? localStorage : sessionStorage
        storage.setItem(LOGIN_KEY, JSON.stringify({ token, user }))
        commit('SET_AUTH', { token, user })
        return user
      })
    },
    restore({ commit }) {
      const raw = localStorage.getItem(LOGIN_KEY) || sessionStorage.getItem(LOGIN_KEY)
      if (!raw) return Promise.resolve(false)
      try {
        const { token, user } = JSON.parse(raw)
        commit('SET_AUTH', { token, user })
        return true
      } catch (e) {
        return Promise.resolve(false)
      }
    },
    logout({ commit }) {
      localStorage.removeItem(LOGIN_KEY)
      sessionStorage.removeItem(LOGIN_KEY)
      commit('CLEAR_AUTH')
    }
  }
}
